import { render, staticRenderFns } from "./ExhibitCard.vue?vue&type=template&id=9ce65228&scoped=true&"
import script from "./ExhibitCard.vue?vue&type=script&lang=js&"
export * from "./ExhibitCard.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitCard.vue?vue&type=style&index=0&id=9ce65228&lang=stylus&scoped=true&"
import style1 from "./ExhibitCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce65228",
  null
  
)

export default component.exports